import { actionForState } from "../../common/functions/utils";

import {
    GET_NOTIFICATION_LIST,
    DELETE_NOTIFICATION,
    DELETE_ALL_NOTIFICATIONS,
    MARK_NOTIFICATIONS_AS_VIEWED,
    REPORT_ERROR,
} from './types';

import { toast } from "react-toastify";
toast.configure();

export const INITIAL_STATE = {
    notifications: [],
    actionForGetNotificationList: {
        loading: false,
        success: false,
        error: false,
    },
    actionForDeleteNotification: {
        loading: false,
        success: false,
        error: false,
    },
    actionForDeleteMultipleNotifications: {
        loading: false,
        success: false,
        error: false,
    },
    actionForMarkNotificationsAsViewed: {
        loading: false,
        success: false,
        error: false,
    },
    actionForReportError: {
        loading: false,
        success: false,
        error: false,
    },
}

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        case GET_NOTIFICATION_LIST.pending:
            return {
                ...state,
                actionForGetNotificationList: actionForState(state.action, 'pending'),
            }
        case GET_NOTIFICATION_LIST.success:
            return {
                ...state,
                notifications: action.payload.data,
                actionForGetNotificationList: actionForState(state.action, 'success'),
            }
        case GET_NOTIFICATION_LIST.error:
            toast.error(action.payload.message);
            return {
                ...state,
                actionForGetNotificationList: actionForState(state.action, 'error', action.payload.message),
            }

        case DELETE_NOTIFICATION.pending:
            return {
                ...state,
                actionForDeleteNotification: actionForState(state.action, 'pending'),
            }
        case DELETE_NOTIFICATION.success:
            toast.success("Notification has been successfully deleted.");
            return {
                ...state,
                notifications: state.notifications.filter(notification => notification.id !== Number(action.payload.id)),
                actionForDeleteNotification: actionForState(state.action, 'success'),
            }
        case DELETE_NOTIFICATION.error:
            toast.error(action.payload.message)
            return {
                ...state,
                actionForDeleteNotification: actionForState(state.action, 'error', action.payload.message),
            }

        case DELETE_ALL_NOTIFICATIONS.pending:
            return {
                ...state,
                actionForDeleteMultipleNotifications: actionForState(state.action, 'pending'),
            }
        case DELETE_ALL_NOTIFICATIONS.success:
            toast.success("All notifications have been deleted successfully.");
            return {
                ...state,
                notifications: [],
                actionForDeleteMultipleNotifications: actionForState(state.action, 'success'),
            }
        case DELETE_ALL_NOTIFICATIONS.error:
            toast.error(action.payload.message)
            return {
                ...state,
                actionForDeleteMultipleNotifications: actionForState(state.action, 'error', action.payload.message),
            }

        case MARK_NOTIFICATIONS_AS_VIEWED.pending:
            return {
                ...state,
                actionForMarkNotificationsAsViewed: actionForState(state.action, 'pending'),
            }
        case MARK_NOTIFICATIONS_AS_VIEWED.success:
            const notifications_updated = state.notifications.map(notification => {
                if (action.payload.notificationIdList.includes(notification.id)) {
                    return {
                        ...notification,
                        status: "Viewed",
                    };
                };
                return notification;
            });
            return {
                ...state,
                notifications: notifications_updated,
                actionForMarkNotificationsAsViewed: actionForState(state.action, 'success'),
            }
        case MARK_NOTIFICATIONS_AS_VIEWED.error:
            toast.error(action.payload.message)
            return {
                ...state,
                actionForMarkNotificationsAsViewed: actionForState(state.action, 'error', action.payload.message),
            }
        
        case REPORT_ERROR.pending:
            return {
                ...state,
                actionForReportError: actionForState(state.action, 'pending'),
            }
        case REPORT_ERROR.success:
            toast.success(action.payload.message);
            return {
                ...state,
                actionForReportError: actionForState(state.action, 'success'),
            }
        case REPORT_ERROR.error:
            toast.error(action.payload.message)
            return {
                ...state,
                actionForReportError: actionForState(state.action, 'error', action.payload.message),
            }
        
        default:
            return state;
    }
}